import React, { useEffect, useRef, useState } from 'react';
import css from './PageLayoutTopMenu.less';
import { Bind } from 'lodash-decorators';
import { KdevIconFont } from '../../../KdevIconFont';
import { common_system_setting } from '@kid/enterprise-icon/icon/output/icons';
import { ITopMenuItem, ITopMenuSection } from './types';

type TOnMenuClick = (webUrl: string, blank: boolean) => void;

interface IProps {
    showSectionTitle?: boolean;
    allMenuList: ITopMenuSection[];
    onMenuClick: TOnMenuClick;
    onClose: () => void;
    onFooterClick?: () => void;
    allMenuPaneFooter?: React.ReactElement | null;
    platform?: 'KDev' | 'KTest';
}

interface IMenuItemProps {
    menu: ITopMenuItem;
    onClick(): void;
}

function MenuItem(props: IMenuItemProps) {
    const { menu, onClick } = props;
    const menuItemRef = useRef<HTMLDivElement>(null);
    const [isHover, setIsHover] = useState<boolean>(false);

    const onMouseEnter = () => {
        setIsHover(true);
    };

    const onMouseLeave = () => {
        setIsHover(false);
    };

    useEffect(() => {
        menuItemRef.current?.addEventListener('mouseenter', onMouseEnter);
        menuItemRef.current?.addEventListener('mouseleave', onMouseLeave);

        return () => {
            menuItemRef.current?.removeEventListener('mouseenter', onMouseEnter);
            menuItemRef.current?.removeEventListener('mouseleave', onMouseLeave);
        };
    }, []);

    return (
        <div className={css.menuItemBox} onClick={onClick} ref={menuItemRef}>
            <div className={css.menuIcon}>
                <img src={menu.iconUrl} />
            </div>
            <span className={css.menuName}>{menu.name}</span>
            <span className={css.blankIconWrap}>{isHover && menu.blankIcon}</span>
        </div>
    );
}

export class PageLayoutTopAllMenu extends React.Component<IProps> {
    customMenuRef = React.createRef();

    @Bind
    renderMenuSection(section: ITopMenuSection) {
        const groupName = section.groupName;
        const showGroupName = this.props.showSectionTitle === false ? false : true;

        return (
            <div className={css.menuSection}>
                {showGroupName && <div className={css.menuSectionTitle}>{groupName}</div>}
                <div className={css.menuSectionMenuBox}>
                    {section.children &&
                        section.children.map((menu: ITopMenuItem) => {
                            return (
                                <MenuItem
                                    key={menu.id}
                                    menu={menu}
                                    onClick={() => {
                                        this.props.onMenuClick?.(
                                            menu.webUrl || '',
                                            menu.blank || section.blank || false
                                        );
                                    }}
                                />
                            );
                        })}
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className={css.popoverContent}>
                    <div className={css.menuPopoverHeader}>
                        <div className={css.headerLeft}>{this.props?.platform || 'KDev'}</div>
                        <div
                            className={`kdev-page-v2-custom-menu-btn ${css.headerRight}`}
                            onClick={() => {
                                this.props.onClose?.();
                            }}
                        >
                            <KdevIconFont className={css.icon} id={common_system_setting} />
                            &thinsp;自定义导航菜单
                        </div>
                    </div>
                    <div className={css.menuPopoverContent}>
                        {this.props.allMenuList.map((group) => this.renderMenuSection(group))}
                        <div onClick={this.props.onFooterClick}>{this.props.allMenuPaneFooter}</div>
                    </div>
                </div>
            </>
        );
    }
}
